import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "v2_sms",
  "use": "v2_sms-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"v2_sms\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect width=\"30\" height=\"30\" fill=\"#1ABC9C\" rx=\"4\" />\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M23.8 5H6.2C4.99 5 4 5.9 4 7v18l4.4-4h15.4c1.21 0 2.2-.9 2.2-2V7c0-1.1-.99-2-2.2-2z\" />\n        <text fill=\"#1ABC9C\" font-family=\"HelveticaNeue-Medium, Helvetica Neue\" font-size=\"8\" font-weight=\"400\" letter-spacing=\"-.114\">\n            <tspan x=\"6\" y=\"16\">SMS</tspan>\n        </text>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol